/* eslint import/order: 0 */
import { createRoot } from 'react-dom/client'
import App from 'App'
import '@signifyd/ant/dist/index.less'
import 'antd/dist/reset.css'
import '@ant-design/v5-patch-for-react-19'
import './index.less'

createRoot(document.getElementById('root')!).render(<App />)
